import { useCallback } from 'react'
import { createSearchParams, useSearchParams, type SetURLSearchParams } from 'react-router-dom'

/** Explicit view choices push history; callers retain replace for automatic
 * normalization or completed writes. Selecting the same URL is not a new stop. */
export function useNavigationParams(): [URLSearchParams, SetURLSearchParams] {
  const [params, setParams] = useSearchParams()
  const update = useCallback<SetURLSearchParams>(
    (next, options) => {
      const value = typeof next === 'function' ? next(new URLSearchParams(params)) : next
      const candidate = createSearchParams(value)
      if (candidate.toString() !== params.toString()) setParams(candidate, options)
    },
    [params, setParams]
  )
  return [params, update]
}
